<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-autocomplete
        class="mt-4 mb-n2"
        v-model="guard_building.building"
        :items="selectors.buildings"
        label="Здание"
        outlined
        item-value="uid"
        item-text="name"
        :error="hasError('building')"
        :errorMessages="getError('building')"
    >
      <template v-slot:label>
        Здание <strong class="red--text">*</strong>
      </template>
    </v-autocomplete>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

export default {
  name: "GuardBuildingDetailBuildingEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    guardBuildingData: Object,
    post: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog
  },
  data() {
    return {
      save_loading: false,
      guard_building_default: {
        building: undefined
      },
      selectors: {
        buildings: undefined
      },
      guard_building: undefined
    }
  },
  computed: {
    form_title() {
      return this.edit === false ? "Добавить здание" : "Редактировать здание"
    }
  },
  methods: {
    ...mapActions({
      createGuardBuilding: "admin/createGuardBuilding",
      changeGuardBuilding: "admin/changeGuardBuilding",
      loadBuildingsSelector: "selectors/loadBuildingsSelector"
    }),
    close(){
      this.$emit("close", false)
    },
    loadGuardBuildingData(){
      this.loadBuildingsSelector({
        url: undefined,
        gets: { territory: this.post.territory.uid },
        finalizer: (val) => {
          this.selectors.buildings = val
        }
      })

      if(this.guardBuildingData === undefined){
        this.guard_building = this.guard_building_default
      }
      else{
        this.guard_building = JSON.parse(JSON.stringify(this.guardBuildingData))
      }
    },
    save(){
      this.save_loading = true
      if (this.edit) {
        this.changeGuardBuilding({
          post_id: this.post.id,
          id: this.guard_building.id,
          data: {
            building: this.guard_building.building
          },
          finalizer: (val) => {
            this.$emit("close", this.guard_building)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }else {
        this.createGuardBuilding({
          post_id: this.post.id,
          data: this.guard_building,
          finalizer: (val) => {
            this.$emit("close", this.guard_building)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadGuardBuildingData()
  }
}
</script>

<style scoped>

</style>
